import { Component, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, Params, NavigationEnd } from '@angular/router'; 
import { isBrowser } from 'angular2-universal';

import { ConfigService } from '../shared/config.service';
import { UtilsService } from '../shared/utils.service';
import { ContentService } from '../shared/content.service';
import { MetaService } from '../shared/meta.service';
import { IntlService } from '../shared/intl.service';

// jQuery so as to hack the faulty CSR of the cover that needs a resize
declare var $: any; //

@Component({
  template: require('./partials/home.html'),
})
export class HomeComponent implements OnInit, AfterViewInit {
    
    public about: Object;
    public currentLanguage: string;

    constructor(public config: ConfigService, public intl: IntlService, private metaService: MetaService, private contentService: ContentService, public utils: UtilsService, private rootNode: ElementRef, private route: ActivatedRoute, private router: Router) {
    }

    public setCurrentLanguage(){
        // Language is made available by the root parent route
        // this.route.parent.params.subscribe(
        //     (params: Params) => {
        //         this.currentLanguage = params['lg'];
        //     }
        // );
        // Above does not work for path like '', 'en'. See routing config
        if(this.route.snapshot.url[0]){
            this.currentLanguage = this.route.snapshot.url[0].path;
        }
    }

    ngOnInit(){
        this.setCurrentLanguage();
        // meta
        this.metaService.setMeta('Forgotten Records | ' + this.intl.data.COMMON.HEADLINE[this.currentLanguage],this.intl.data.COMMON.SUMMARY[this.currentLanguage], this.intl.data.COMMON.KEYWORDS[this.currentLanguage]);
        this.metaService.setLanguage(this.currentLanguage);
        this.contentService.getContent('page', {url: 'about'}).then(response => {
          this.about = response;
        });
    }

    // Hack full-screen image
    ngAfterViewInit() {
      if(isBrowser){
        $(document).ready(function() {
            $("#full-screen-home").addClass("full-screen");
            $(window).trigger('resize');
        });
        
      }
    }

    ngAfterContentChecked(){
        if(!this.currentLanguage){
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
            // Meta language
            this.metaService.setLanguage(this.currentLanguage);
        }     
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/home.component.ts